import React, { useState } from 'react';
import CustomTrukeySection from './customTrukeySection';
import CustomEropaSection from './customEroupaSection';
import { useTranslation } from 'react-i18next';
export default function CartChooseButton({boxNumber}) {
  const [selectedMenuItem, setSelectedMenuItem] = useState('CustomTrukeySection');
  const {t} =useTranslation();
  const handleMenuItemClick = (menuItem) => {
    setSelectedMenuItem(menuItem);
  };

  return (
    <>
      <div className='flex flex-col gap-4'>
          <h1 className='text-xl font-medium text-red-700 lg:text-2xl'>{t("YourAssignedBoxAddress")}</h1>
          <p className='text-sm text-black lg:text-lg'>{t("YourAssignedBoxAddressParg")}</p>
        </div>
      <div className="flex flex-col items-center w-full mt-10 ">
       
        {/* Buttons Section */}
        <div className="flex gap-4 mb-6">
          <button
            className={`md:text-lg px-6 py-3 font-medium md:font-bold focus:outline-none transition-colors ${
              selectedMenuItem === 'CustomTrukeySection' ? 'bg-custom-yellow text-black' : 'bg-white text-black'
            }`}
            onClick={() => handleMenuItemClick('CustomTrukeySection')}
          >
      {t("TurkishBox")}
          </button>
          <button
            className={`md:text-lg px-6 py-3 md:font-bold font-medium  focus:outline-none transition-colors ${
              selectedMenuItem === 'CustomEropaSection' ? 'bg-custom-yellow text-black' : 'bg-white text-black'
            }`}
            onClick={() => handleMenuItemClick('CustomEropaSection')}
          >
        {t("EuropeBox")}
          </button>
        </div>

        {/* Content Section */}
        <div className="w-full">
          {selectedMenuItem === 'CustomTrukeySection' && (
            <div>
              <CustomTrukeySection boxNumber={boxNumber}/>
            </div>
          )}
          {selectedMenuItem === 'CustomEropaSection' && (
            <div>
              <CustomEropaSection boxNumber={boxNumber}/>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
